import { AppConfig } from '../../../app/shared/app-config/app-config.model'
import { defaultAppConfig } from '../../../app/shared/app-config/app-config-default'

export const appConfig: AppConfig = {
  ...defaultAppConfig,
  core: {
    ...defaultAppConfig.core,
    recaptcha: { ...defaultAppConfig.core.recaptcha, siteKey: '6LfgApoUAAAAABr6a3oF89UDwZ19AH7JIltamTKs' },
    documentTitle: 'BusitaliaVeneto Account',
    brandName: 'Busitalia Veneto',
    clientName: 'pw-busitaliaveneto',
    cardLayoutLogo: {
      ...defaultAppConfig.core.cardLayoutLogo,
      default: {
        ...defaultAppConfig.core.cardLayoutLogo.default,
        height: 89,
        width: 275,
      },
    },
  },
  myCiceroWebApi: {
    ...defaultAppConfig.myCiceroWebApi,
    urls: {
      ...defaultAppConfig.myCiceroWebApi.urls,
      _base: 'https://www.mycicero.it/Net.Pluservice.Api.ProfilazioneWeb/api',
    },
  },
}
